
import SouthMelbourneSewerageContent from 'components/Content/SouthMelbourneSewerage';
import SouthMelbourneNormanbyRdContent from 'components/Content/SouthMelbourneNormanbyRd';
import DingleyTrunkMainContent from './Content/DingleyTrunkMain';
import DingleyPumpStationContent from './Content/DingleyPumpStation';
import DingleyWestNetworkContent from './Content/DingleyWestNetwork';
import DingleyNorthNetworkStage1Content from './Content/DingleyNorthNetworkStage1';
import DingleyNorthNetworkStage2Content from './Content/DingleyNorthNetworkStage2';
import DingleySouthNetworkContent from './Content/DingleySouthNetwork';
import FBRecycledWaterMainsContent from './Content/FBRecycledWaterMains';
import FBRecycledWaterMainsNorthContent from './Content/FBRecycledWaterMainsNorth';
import FBSewerMiningPumpStationContent from './Content/FBSewerMiningPumpStation';
import FBWaterRecyclingPlantContent from './Content/FBWaterRecyclingPlant';
import FBMelbourneWaterContent from './Content/FBMelbourneWater';
import FBReticulationPipesContent from './Content/FBReticulationPipes';
import FBFishermansBendContent from './Content/FBFishermansBend';
import SouthMelbournePumpStationContent from './Content/SouthMelbournePumpStation';
import FBSalmonStPumpStationContent from './Content/FBSalmonStPumpStation';
import WPRecycledWaterSchemeContent from './Content/WPRecycledWaterScheme';
import WPStage1AContent from './Content/WPStage1A';
import WPStage1BContent from './Content/WPStage1B';
import OfficerSouthBallartoContent from './Content/OfficerSouthBallarto';
import BentleighInterceptorBranchSewerRenewalContent from './Content/BentleighInterceptorBranchSewerRenewal';
import SpringvaleSouthSewerUpgradeContent from './Content/SpringvaleSouthSewerUpgrade';
import BarklyStreetWaterMainRenewalContent from './Content/BarklyStreetWaterMainRenewal';
import JasperRoadContent from './Content/JasperRoad';
import McDonaldsTrackContent from './Content/McDonaldsTrack';
import LongwarryStage1Content from './Content/LongwarryStage1';
import LongwarryStage2Content from './Content/LongwarryStage2';
import TuckersRoadContent from './Content/TuckersRoad';
import BallartoRoadStorageTankContent from './Content/BallartoRoadStorageTank';
import FrankstonSouthContent from './Content/FrankstonSouth';
import MountElizaBerkeleyCourtContent from './Content/MountElizaBerkeleyCourt';
import RosebudtoDromanaContent from './Content/RosebudtoDromana';
import OfficerSouthCREPContent from './Content/OfficerSouthCREPContent';


// Projects on hold
// 
// import FBFishermansBendToddRoadContent from './Content/FBFishermansBendToddRoad';


//Projects removed - finalised
// import MountElizaBerkeleyCourtContent from './Content/MountElizaBerkeleyCourt';
// import MelbourneAlbertParkContent from 'components/Content/MelbourneAlbertPark';

import type { RenderType, Project, Shape } from './constants.type';


const SouthMelbourneSewerage = require('assets/data/SouthMelbourneSewerage.json');
const SouthMelbourneNormanbyRd = require('assets/data/SouthMelbourneNormanbyRd.json');
const DingleyTrunkMain = require('../assets/data/DingleyTrunkMain.json');
const DingleyPumpStation = require('../assets/data/DingleyPumpStation.json');
const DingleyNorthConnectionNetworkStage1 = require('../assets/data/DingleyNorthConnectionNetworkStage1.json');
const DingleyNorthConnectionNetworkStage2 = require('../assets/data/DingleyNorthConnectionNetworkStage2.json');
const DingleyWestNetwork = require('../assets/data/DingleyWestNetwork.json');
const DingleySouthNetwork = require('../assets/data/DingleySouthNetwork.json');
const FBRecycledWaterMains = require('../assets/data/FBRecycledWaterMains.json');
const FBRecycledWaterMainsNorth = require('../assets/data/FBRecycledWaterMainsNorth.json');
const FBSewerMiningPumpStation = require('../assets/data/FBSewerMiningPumpStation.json');
const FBWaterRecyclingPlant = require('../assets/data/FBWaterRecyclingPlant.json');
const FBMelbourneWater = require('../assets/data/FBMelbourneWater.json');
const FBReticulationPipes = require('../assets/data/FBReticulationPipes.json');
const FBSalmonStPumpStation = require('../assets/data/FBSalmonStPumpStation.json');
const SouthMelbournePumpStation = require('../assets/data/SouthMelbournePumpStation.json');
const WPStage1A = require('../assets/data/WPStage1A.json');
const WPStage1B = require('../assets/data/WPStage1B.json');
const WPWaterRecyclingPlant = require('../assets/data/WPWaterRecyclingPlant.json');
const OfficerSouthBallarto = require('../assets/data/OfficerSouthBallarto.json');
const BentleighInterceptorBranchSewerRenewal = require('../assets/data/BentleighInterceptorBranchSewerRenewal.json');
const SpringvaleSouthSewerUpgrade = require('../assets/data/SpringvaleSouthSewerUpgrade.json');
const BarklyStreetWaterMainRenewal = require('../assets/data/BarklyStreetWaterMainRenewal.json');
const JasperRoad = require('../assets/data/JasperRoad.json');
const McDonaldsTrack = require('../assets/data/McDonaldsTrack.json');
const LongwarryStage1 = require('../assets/data/LongwarryStage1.json');
const LongwarryStage2 = require('../assets/data/LongwarryStage2.json');
const TuckersRoad = require('../assets/data/TuckersRoad.json');
const FrankstonSouth = require('../assets/data/FrankstonSouth.json');
const MountElizaBerkeleyCourt = require('../assets/data/MountElizaBerkeleyCourt.json');
const RosebudtoDromana = require('../assets/data/RosebudtoDromana.json');
const OfficerSouthCREP = require('../assets/data/OfficerSouthCREP.json');


// Projects on hold
// 
// const FBFishermansBendToddRoadBlue = require('../assets/data/FBFishermansBendToddRoadBlue.json');
// const FBFishermansBendToddRoadOrange = require('../assets/data/FBFishermansBendToddRoadOrange.json');

// Projects removed - finalised
// const MountElizaBerkeleyCourt = require('../assets/data/MountElizaBerkeleyCourt.json');
// const MelbourneAlbertPark = require('assets/data/MelbourneAlbertPark.json');

// Map Configuration
export const mapConfig = {
  centerInitial: [145.2874914, -38.0231387] as [number, number],
  centerInitialDingley: [145.10060245459448, -37.9804784384515] as [
    number,
    number,
  ],
  centerInitialFB: [144.92432452950624, -37.82854643783086] as [number, number],
  zoom: 9.9,
  zoomDingley: 11.8,
  zoomFB: 13.5,
  maxZoom: 18,
  style: 'mapbox://styles/creative-rps/cmc14rqzp00rm01sp9oz33au0',
  legendZoomThreshold: 11,
};

// Clusters Configuration
export const clusters = [
  {
    position: [144.9625645986489, -37.828652859260785] as [number, number],
    color: 'orange',
    counter: 3,
  },
  {
    position: [145.12149855374594, -37.989864401830694] as [number, number],
    color: 'purple',
    counter: 5,
    zoom: 8.5,
  },
  {
    position: [144.94588221354462, -37.836359603409996] as [number, number],
    color: 'darkBlue',
    counter: 1,
  },
  {
    position: [144.9272012863616, -37.82758578479963] as [number, number],
    color: 'purple',
    counter: 7,
  },
  {
    position: [145.61095, -38.1495657] as [number, number],
    color: 'purple',
    counter: 3,
    zoom: 11.5,
  },
  {
    position: [145.3435173559111, -38.11639931527268] as [number, number],
    color: 'purple',
    counter: 1,
    zoom: 11.5,
  },
  {
    position: [145.02705486988089, -37.89947557832637] as [number, number],
    color: 'orange',
    counter: 1,
    zoom: 12.5,
  },
  {
    position: [145.1560773145448, -37.97318079374794] as [number, number],
    color: 'orange',
    counter: 1,
    zoom: 14,
  },
  {
    position: [145.40463011447503, -38.098271824592] as [number, number],
    color: 'orange',
    counter: 2,
    zoom: 11.5,
  },
  {
    position: [145.04215384393916, -38.220509202594535] as [number, number],
    color: 'darkBlue',
    counter: 1,
  },
  {
    position: [145.04279519587914, -37.93090263313407] as [number, number],
    color: 'darkBlue',
    counter: 1,
  },
  {
    position: [145.74808793840333, -38.10486064858211] as [number, number],
    color: 'darkBlue',
    counter: 1,
  },
  {
    position: [145.56590190729963, -38.26062224096631] as [number, number],
    color: 'darkBlue',
    counter: 1,
  },
];

export const colors: { [key: string]: string } = {
  purple: '#8C50B4',
  orange: '#ff571e',
  darkBlue: '#002379',
  blue: '#002379',
};

// Color Mappings
export const categoryColors = {
  'water-renewals': colors.darkBlue,
  'major-projects': colors.orange,
  'recycled-water-projects': colors.purple,
};

// Helper to convert hex to RGB string for rgba() usage
export const hexToRgb = (hex: string): string => {
  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return result
    ? `${parseInt(result[1], 16)}, ${parseInt(result[2], 16)}, ${parseInt(result[3], 16)}`
    : '0, 0, 0';
};

export const projects: Project[] = [
//  {
//    title: 'Mount Eliza - Berkeley Court',
//    value: 'MountElizaBerkeleyCourt',
//    shapes: [
//      {
//        type: 'line',
//        data: MountElizaBerkeleyCourt,
//      },
//    ],
//    category: 'water-renewals',
//    marker: {
//      position: [145.0991520800622, -38.17810902269661],
//      content: MountElizaBerkeleyCourtContent,
//    },
//    color: 'blue',
//    zoomOnClick: 15,
//  },
{
 title: 'Officer South - Cardinia Road Employment Precinct (CREP)',
 value: 'OfficerSouthCREP',
shapes: [
  {
     type: 'line',
     data: OfficerSouthCREP,
    },
    {
      type: 'pulsing-dot',
      coordinates: [145.43466352601195, -38.10037568325384],
    },
   ],
   category: 'major-projects',
   marker: {
     position: [145.43990628364924, -38.08635186417081],
     content: OfficerSouthCREPContent,
   },
   color: 'orange',
   zoomOnClick: 12.5,
 },
  {
    title:
      'Officer South - Ballarto Road Sewer Rising Main and Pump Station Upgrade',
    value: 'OfficerSouthBallarto',
    shapes: [
      {
        type: 'line',
        data: OfficerSouthBallarto,
      },
      {
        type: 'pulsing-dot',
        coordinates: [145.3716305519527, -38.13830732892554],
      },
    ],
    category: 'major-projects',
    marker: {
      position: [145.38337184812627, -38.11144783175023],
      content: OfficerSouthBallartoContent,
    },
    color: 'orange',
    zoomOnClick: 12,
  },
  {
    title:
      'Officer South – Ballarto Road Storage Tank',
    value: 'BallartoRoadStorageTank',
    category: 'major-projects',
    marker: {
      position: [145.3692957698455, -38.13595441508752],
      content: BallartoRoadStorageTankContent,
    },
    color: 'orange',
    zoomOnClick: 14,
  },
  {
    title: 'Bentleigh - Interceptor Branch Sewer Renewal',
    value: 'BentleighInterceptorBranchSewerRenewal',
    shapes: [
      {
        type: 'line',
        data: BentleighInterceptorBranchSewerRenewal,
      },
    ],
    category: 'major-projects',
    marker: {
      position: [145.02705486988089, -37.89947557832637],
      content: BentleighInterceptorBranchSewerRenewalContent,
    },
    color: 'orange',
    zoomOnClick: 12.5,
  },
  {
    title: 'Springvale South - Sewer Upgrade',
    value: 'SpringvaleSouthSewerUpgrade',
    shapes: [
      {
        type: 'line',
        data: SpringvaleSouthSewerUpgrade,
      },
    ],
    category: 'major-projects',
    marker: {
      position: [145.1560773145448, -37.97318079374794],
      content: SpringvaleSouthSewerUpgradeContent,
    },
    color: 'orange',
    zoomOnClick: 14,
  },
  {
    title: 'South Melbourne – Sewer Upgrade',
    value: 'SouthMelbourneSewerage',
    shapes: [
      {
        type: 'line',
        data: SouthMelbourneSewerage,
      },
    ],
    category: 'major-projects',
    marker: {
      position: [144.95970966554285, -37.83425658382797],
      content: SouthMelbourneSewerageContent,
    },
    color: 'orange',
    openPopup: 'bottom',
  },
  {
    title: 'South Melbourne - Normanby Road',
    value: 'SouthMelbourneNormanbyRd',
    shapes: [
      {
        type: 'line',
        data: SouthMelbourneNormanbyRd,
      },
    ],
    category: 'water-renewals',
    marker: {
      position: [144.9463388503081, -37.83101740781016],
      content: SouthMelbourneNormanbyRdContent,
    },
    color: 'blue',
    openPopup: 'bottom',
    zoomOnClick: 16,
  },
  {
    title: 'Dingley Recycled Water Scheme - Transfer Main',
    value: 'DingleyTrunkMain',
    shapes: [
      {
        type: 'line',
        data: DingleyTrunkMain,
        config: {
          defaultOpacity: 0.3,
          dasharray: [1],
        },
      },
    ],
    category: 'major-projects',
    subcategory: 'recycled-water-projects',
    marker: {
      position: [145.15083485608756, -38.008319566464166],
      content: DingleyTrunkMainContent,
    },
    color: 'purple',
    zoomOnClick: 12.5,
  },
  {
    title: 'Dingley Recycled Water Scheme - Pump Station',
    value: 'DingleyPumpStation',
    shapes: [
      {
        type: 'line',
        data: DingleyPumpStation,
      },
      {
        type: 'pulsing-dot',
        coordinates: [145.12143236509382, -37.98993072815919],
      },
    ],
    category: 'major-projects',
    subcategory: 'recycled-water-projects',
    marker: {
      position: [145.1097299726789, -37.988828213682815],
      content: DingleyPumpStationContent,
    },
    color: 'purple',
  },
  {
    title: 'Dingley – West Connection Network',
    value: 'DingleyWestNetwork',
    shapes: [
      {
        type: 'dashed-line',
        data: DingleyWestNetwork,
        config: {
          hasInvisibleHoverLine: true,
          defaultOpacity: 0.7,
          dasharray: [1.5, 2],
        },
      },
    ],
    category: 'major-projects',
    subcategory: 'recycled-water-projects',
    marker: {
      position: [145.05858000321882, -37.980479326540284],
      content: DingleyWestNetworkContent,
    },
    color: 'purple',
    zoomOnClick: 14,
    openPopup: 'bottom',
  },
  {
    title: 'Dingley - North Connection Network Stage 1',
    value: 'DingleyNorthConnectionNetworkStage1',
    shapes: [
      {
        type: 'dashed-line',
        data: DingleyNorthConnectionNetworkStage1,
        config: {
          hasInvisibleHoverLine: true,
          defaultOpacity: 0.7,
          dasharray: [1.5, 2],
        },
      },
    ],
    category: 'major-projects',
    subcategory: 'recycled-water-projects',
    marker: {
      position: [145.12781723381426, -37.93974345248799],
      content: DingleyNorthNetworkStage1Content,
    },
    color: 'purple',
    zoomOnClick: 12.5,
  },
  {
    title: 'Dingley - North Connection Network Stage 2',
    value: 'DingleyNorthConnectionNetworkStage2',
    shapes: [
      {
        type: 'dashed-line',
        data: DingleyNorthConnectionNetworkStage2,
        config: {
          hasInvisibleHoverLine: true,
          defaultOpacity: 0.7,
          dasharray: [1.5, 2],
        },
      },
    ],
    category: 'major-projects',
    subcategory: 'recycled-water-projects',
    marker: {
      position: [145.13187684698028, -37.9491465061646],
      content: DingleyNorthNetworkStage2Content,
    },
    color: 'purple',
    zoomOnClick: 12.5,
  },
  {
    title: 'Dingley – South Connection Network',
    value: 'DingleySouthNetwork',
    shapes: [
      {
        type: 'dashed-line',
        data: DingleySouthNetwork,
        config: {
          hasInvisibleHoverLine: true,
          defaultOpacity: 0.7,
          dasharray: [1.5, 2],
        },
      },
    ],
    category: 'major-projects',
    subcategory: 'recycled-water-projects',
    marker: {
      position: [145.14298583773905, -37.98160971996259],
      content: DingleySouthNetworkContent,
    },
    color: 'purple',
    zoomOnClick: 14,
  },
  {
    title: 'Fishermans Bend - Sewer Mining Pump Station',
    value: 'FBSewerMiningPumpStation',
    shapes: [
      {
        type: 'line',
        data: FBSewerMiningPumpStation,
      },
      {
        type: 'pulsing-dot',
        coordinates: [144.90205516588333, -37.83312646612627],
      },
    ],
    category: 'major-projects',
    subcategory: 'recycled-water-projects',
    marker: {
      position: [144.90209243326086, -37.8335453248203],
      content: FBSewerMiningPumpStationContent,
    },
    color: 'purple',
    zoomOnClick: 16,
  },
  {
    title: 'Fishermans Bend - Water Recycling Plant',
    value: 'FBWaterRecyclingPlant',
    shapes: [
      {
        type: 'polygon-with-line',
        data: FBWaterRecyclingPlant,
        config: {
          polygonOpacity: 0.5,
        },
      },
    ],
    category: 'major-projects',
    subcategory: 'recycled-water-projects',
    marker: {
      position: [144.90330018367303, -37.82868562375472],
      content: FBWaterRecyclingPlantContent,
    },
    color: 'purple',
  },
  {
    title: 'Melbourne Water - Hobsons Bay Main Upgrade Project',
    value: 'FBMelbourneWater',
    shapes: [
      {
        type: 'polygon-with-line',
        data: FBMelbourneWater,
        config: {
          polygonOpacity: 0.5,
        },
      },
    ],
    category: 'major-projects',
    subcategory: 'recycled-water-projects',
    marker: {
      position: [144.89929034864235, -37.831759832906364],
      content: FBMelbourneWaterContent,
    },
    color: 'purple',
    zoomOnClick: 16,
  },
  {
    title: 'Fishermans Bend - Reticulation Pipes',
    value: 'FBReticulationPipes',
    shapes: [
      {
        type: 'polygon-with-line',
        data: FBReticulationPipes,
        config: {
          polygonOpacity: 0.2,
          dasharray: [1.5, 2],
          useDashedBorder: true,
          disablePolygonClick: true,
          disablePolygonHover: true,
          openOpacity: 0.6,
          hoverOpacity: 0.6,
          resetOpacity: 0.2,
        },
      },
    ],
    category: 'major-projects',
    subcategory: 'recycled-water-projects',
    marker: {
      position: [144.94421847537274, -37.82450870183152],
      content: FBReticulationPipesContent,
    },
    color: 'purple',
  },
  {
    title: 'Fishermans Bend - Project Overview',
    value: 'FBFishermansBend',
    // features: FBFishermansBend,
    category: 'major-projects',
    subcategory: 'recycled-water-projects',
    marker: {
      position: [144.9240275156381, -37.819727612493416],
      content: FBFishermansBendContent,
    },
    color: 'purple',
    openPopup: 'top',
    skipInteraction: true,
  },
  {
    title: 'Fishermans Bend - Recycled Water Mains (Trunk) Southern',
    value: 'FBRecycledWaterMains',
    shapes: [
      {
        type: 'line',
        data: FBRecycledWaterMains,
      },
    ],
    category: 'major-projects',
    subcategory: 'recycled-water-projects',
    marker: {
      position: [144.9286848464571, -37.83496658152228],
      content: FBRecycledWaterMainsContent,
    },
    color: 'purple',
    openPopup: 'bottom',
  },
  {
    title: 'Fishermans Bend - Recycled Water Mains (Trunk) Northern',
    value: 'FBRecycledWaterMainsNorth',
    shapes: [
      {
        type: 'line',
        data: FBRecycledWaterMainsNorth,
      },
    ],
    category: 'major-projects',
    subcategory: 'recycled-water-projects',
    marker: {
      position: [144.93102301409442, -37.82241869535412],
      content: FBRecycledWaterMainsNorthContent,
    },
    color: 'purple',
  },
  {
    title: 'South Melbourne Sewer Upgrade – Market Street Pump Station',
    value: 'SouthMelbournePumpStation',
    shapes: [
      {
        type: 'line',
        data: SouthMelbournePumpStation,
      },
      {
        type: 'pulsing-dot',
        coordinates: [144.96256656361612, -37.8286538199583],
      },
    ],
    category: 'major-projects',
    marker: {
      position: [144.9679115659482, -37.82853358105545],
      content: SouthMelbournePumpStationContent,
    },
    color: 'orange',
  },

  {
    title: 'Salmon Street - Sewer Pump Station Relocation',
    value: 'FBSalmonStPumpStation',
    shapes: [
      {
        type: 'line',
        data: FBSalmonStPumpStation,
        config: {
          defaultOpacity: 0.3,
        },
      },
      {
        type: 'pulsing-dot',
        coordinates: [144.9217135027426, -37.823982585840696],
      },
      {
        type: 'pulsing-dot',
        coordinates: [144.91880865819468, -37.82562412463424],
        label: 'Future pump station',
      },
    ],
    category: 'major-projects',
    marker: {
      position: [144.91873681138355, -37.823074022768914],
      content: FBSalmonStPumpStationContent,
    },
    color: 'orange',
    zoomOnClick: 15.5,
  },
  {
    title: 'Western Port Recycled Water Scheme - Project overview',
    value: 'WPRecycledWaterScheme',
    category: 'major-projects',
    subcategory: 'recycled-water-projects',
    marker: {
      position: [145.6293645, -38.112065],
      content: WPRecycledWaterSchemeContent,
    },
    color: 'purple',
    openPopup: 'top',
    zoomOnClick: 11.5,
    skipInteraction: true,
  },
  {
    title: 'Western Port Recycled Water Scheme - Stage 1A',
    value: 'WPStage1A',
    shapes: [
      {
        type: 'line',
        data: WPStage1A,
      },
    ],
    category: 'major-projects',
    subcategory: 'recycled-water-projects',
    marker: {
      position: [145.5693992, -38.1322561],
      content: WPStage1AContent,
    },
    color: 'purple',
    openPopup: 'top',
    zoomOnClick: 12,
  },
  {
    title: 'Western Port Recycled Water Scheme - Stage 1B',
    value: 'WPStage1B',
    shapes: [
      {
        type: 'dashed-line',
        data: WPStage1B,
        config: {
          hasInvisibleHoverLine: true,
          defaultOpacity: 0.7,
          dasharray: [1.5, 2],
        },
      },
    ],
    category: 'major-projects',
    subcategory: 'recycled-water-projects',
    marker: {
      position: [145.6992694, -38.1649151],
      content: WPStage1BContent,
    },
    color: 'purple',
    openPopup: 'bottom',
    zoomOnClick: 12,
  },
  {
    title: 'Pakenham Water Recycling Plant',
    value: 'WPWaterRecyclingPlant',
    shapes: [
      {
        type: 'polygon-with-line',
        data: WPWaterRecyclingPlant,
        config: {
          polygonOpacity: 0.2,
          hoverOpacity: 0.2,
          resetOpacity: 0.2,
        },
      },
      {
        type: 'pulsing-dot',
        coordinates: [145.4894079, -38.1118846],
      },
    ],
    category: 'major-projects',
    subcategory: 'recycled-water-projects',
    marker: {
      position: [145.4944251, -38.113490855638375],
      content: null,
    },
    color: 'purple',
    openPopup: 'top',
    zoomOnClick: 12,
    skipInteraction: true,
  },
  {
    title: 'Mornington - Barkly Street',
    value: 'BarklyStreetWaterMainRenewal',
    shapes: [
      {
        type: 'line',
        data: BarklyStreetWaterMainRenewal,
      },
    ],
    category: 'water-renewals',
    marker: {
      position: [145.04176757868885, -38.21905860510971],
      content: BarklyStreetWaterMainRenewalContent,
    },
    color: 'blue',
    openPopup: 'top',
    zoomOnClick: 16,
  },
  {
    title: 'Bentleigh - Jasper Road',
    value: 'JasperRoad',
    shapes: [
      {
        type: 'line',
        data: JasperRoad,
      },
    ],
    category: 'water-renewals',
    marker: {
      position: [145.0338140148765, -37.929413129201606],
      content: JasperRoadContent,
    },
    color: 'blue',
    openPopup: 'top',
    zoomOnClick: 15,
  },
  {
    title: 'Lang Lang - McDonalds Track',
    value: 'McDonaldsTrack',
    shapes: [
      {
        type: 'line',
        data: McDonaldsTrack,
      },
    ],
    category: 'water-renewals',
    marker: {
      position: [145.56340128467178, -38.26049076092979],
      content: McDonaldsTrackContent,
    },
    color: 'blue',
    openPopup: 'top',
    zoomOnClick: 14,
  },
  {
    title: 'Longwarry - Watermain Renewal and Upgrade Stage 1',
    value: 'LongwarryStage1',
    shapes: [
      {
        type: 'line',
        data: LongwarryStage1,
      },
    ],
    category: 'water-renewals',
    marker: {
      position: [145.76009084870475, -38.09834524437865],
      content: LongwarryStage1Content,
    },
    color: 'blue',
    openPopup: 'top',
    zoomOnClick: 13,
  },
  {
    title: 'Longwarry - Watermain Renewal and Upgrade Stage 2',
    value: 'LongwarryStage2',
    shapes: [
      {
        type: 'dashed-line',
        data: LongwarryStage2,
      },
    ],
    category: 'water-renewals',
    marker: {
      position: [145.7409324277507, -38.09858115244321],
      content: LongwarryStage2Content,
    },
    color: 'blue',
    openPopup: 'top',
    zoomOnClick: 13,
  },
  {
    title: 'Clyde North - Tuckers Road Recycled Water Main',
    value: 'TuckersRoad',
    category: 'major-projects',
    shapes: [
      {
        type: 'line',
        data: TuckersRoad,
      },
    ],
    subcategory: 'recycled-water-projects',
    marker: {
      position: [145.33610709854878, -38.11547666675446],
      content: TuckersRoadContent,
    },
    color: 'purple',
    openPopup: 'top',
    zoomOnClick: 14,
  },
 // {
//    title: 'Fishermans Bend - Todd Road Sewer and Water Project',
 //   value: 'FBFishermansBendToddRoad',
 //   shapes: [
 //     {
 //       type: 'line',
//        data: FBFishermansBendToddRoadBlue,
//        color: 'darkBlue',
 //     },
 //     {
 //       type: 'line',
 //       data: FBFishermansBendToddRoadOrange,
 //       color: 'orange',
 //     },
 //   ],
 //   category: 'major-projects',
//    categoryColor: 'darkBlue',
//    marker: {
 //     position: [144.91913492402813, -37.83048554647316],
  //    content: FBFishermansBendToddRoadContent,
 //   },
 //   color: 'darkBlue',
 //   openPopup: 'bottom',
 //   zoomOnClick: 14.6,
 // },
 //{
  //title: 'Rosebud to Dromana',
 // value: 'RosebudtoDromana',
 // shapes: [
 //   {
 //     type: 'line',
//      data: RosebudtoDromana,
 //   },
  //],
 // category: 'water-renewals',
 // marker: {
 //   position: [144.90536944816301, -38.346426486110296],
 //   content: RosebudtoDromanaContent,
 // },
 // color: 'blue',
 // openPopup: 'top',
//  zoomOnClick: 13,
//},
//{
//  title: 'Frankston South - Humphries Roadd and Brighton Street',
//  value: 'FrankstonSouth',
//  shapes: [
//    {
//      type: 'line',
//      data: FrankstonSouth,
//    },
//  ],
//  category: 'water-renewals',
//  marker: {
//    position: [145.10426282427034, -38.1657478307672],
//    content: FrankstonSouthContent,
//  },
//  color: 'blue',
//  openPopup: 'top',
//  zoomOnClick: 13,
//},
//{
//  title: 'Mount Eliza - Koornalla Crescent Sewer',
//  value: 'MountElizaBerkeleyCourt',
//  shapes: [
//    {
//      type: 'line',
//      data: MountElizaBerkeleyCourt,
//    },
//  ],
//  category: 'major-projects',
//  marker: {
//    position: [145.09486720551905, -38.18601478414831],
//    content: MountElizaBerkeleyCourtContent,
//  },
//  color: 'orange',
//  openPopup: 'bottom',
//},
];

// Helper functions for shapes
export const getShapesByType = (project: Project, type: string) => {
  return project.shapes?.filter((shape) => shape.type === type) || [];
};

export const getPrimaryGeoJSONShape = (project: Project) => {
  return project.shapes?.find((shape) => shape.type !== 'pulsing-dot') as
    | Extract<
        Shape,
        { type: 'line' | 'polygon' | 'dashed-line' | 'polygon-with-line' }
      >
    | undefined;
};

export const getPulsingDotShapes = (project: Project) => {
  return project.shapes?.filter(
    (shape) => shape.type === 'pulsing-dot',
  ) as Extract<Shape, { type: 'pulsing-dot' }>[];
};

export const getProjectRenderType = (
  project: Project,
): RenderType | undefined => {
  const primaryShape = getPrimaryGeoJSONShape(project);
  return primaryShape?.type;
};

// Helper functions
export const getCategoryColor = (
  category: string,
  subcategory?: string,
  categoryColorOverride?: string,
): string => {
  // If categoryColor is provided, use that
  if (categoryColorOverride && colors[categoryColorOverride]) {
    return colors[categoryColorOverride];
  }
  // Otherwise use category-based color
  if (subcategory === 'recycled-water-projects') {
    return categoryColors['recycled-water-projects'];
  }
  return categoryColors[category as keyof typeof categoryColors] || '#000000';
};

export const getProjectsByRenderType = (renderType: RenderType) => {
  return projects.filter((p) => {
    const type = getProjectRenderType(p);
    return type === renderType;
  });
};

export const getDashedLineProjects = () => {
  return projects
    .filter((p) => getProjectRenderType(p) === 'dashed-line')
    .map((p) => p.value);
};

export const getPolygonProjects = () => {
  return projects
    .filter((p) => {
      const type = getProjectRenderType(p);
      return type === 'polygon-with-line' || type === 'polygon';
    })
    .map((p) => p.value);
};
